'use client';

import { cn } from '@coas/ui/lib';
import type * as React from 'react';

interface AuthShellProps {
    header?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
}

export default ({ header, children, className }: AuthShellProps) => (
    <section className={cn('relative flex w-full flex-col bg-neutral-50 shadow-md', className)}>
        {header && <header className='flex w-full items-stretch border-neutral-300 border-b-2'>{header}</header>}

        <div className='p-6'>{children}</div>
    </section>
);
